import { IconType } from "@/app/components/icons/icon.type";

const PDFFileIcon = ({ style, className }: IconType) => (
  <svg
    style={style}
    className={className}
    width="33"
    height="38"
    viewBox="0 0 33 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_466_30243)">
      <rect
        x="0.620117"
        width="32"
        height="38"
        rx="6"
        fill="#E5484D"
        stroke="#01012E"
        strokeOpacity="0.134"
        strokeWidth="0.59375"
      />
      <g clipPath="url(#clip1_466_30243)">
        <rect
          width="16"
          height="16"
          transform="translate(7.62012 12)"
          fill="white"
          fillOpacity="0.01"
        />
        <path
          d="M16.4105 16.1766C16.3406 17.0496 16.1695 17.9146 15.8974 18.7636C15.8741 18.8437 15.8819 18.9077 15.9207 18.9878C16.3406 19.7007 16.9003 20.2373 17.5456 20.9501C17.6311 21.0462 17.7322 21.1423 17.8177 21.2384C17.8566 21.2865 17.9032 21.2945 17.9654 21.2865C18.7507 21.1744 19.5359 21.1023 20.3289 21.1263C20.8809 21.1423 21.4251 21.2064 21.9538 21.3906C22.2414 21.4947 22.5058 21.6309 22.7235 21.8391C22.9956 22.1035 23.1588 22.4318 23.1122 22.8243C23.0578 23.3129 22.8245 23.6893 22.3658 23.8895C22.1559 23.9776 21.9382 24.0257 21.7128 24.0337C21.0131 24.0737 20.3367 23.9456 19.6836 23.6813C18.9373 23.3849 18.2686 22.9444 17.6622 22.4078C17.5689 22.3277 17.4912 22.3117 17.3823 22.3357C16.2006 22.576 15.1822 22.9925 14.2026 23.3209C14.1326 23.3449 14.0937 23.3769 14.0626 23.441C13.1996 24.9708 11.878 26.869 10.1209 27.4136C9.64667 27.5578 9.19574 27.5257 8.75259 27.2855C8.29389 27.0372 7.95959 26.4445 8.2006 25.7717C8.27057 25.5715 8.37941 25.3953 8.51158 25.2351C8.76037 24.9227 9.06357 24.6584 9.38233 24.4261C9.9732 23.9936 10.6107 23.6412 11.2638 23.3289C11.5514 23.1847 11.8469 23.0485 12.1423 22.9284C12.2045 22.9044 12.2511 22.8563 12.2822 22.7923C13.0675 21.2705 13.7283 19.6846 14.2725 18.0508C14.3269 17.8906 14.3269 17.7544 14.257 17.5942C13.9693 16.9134 13.7594 16.2086 13.635 15.4718C13.5495 14.9592 13.5184 14.4466 13.5806 13.926C13.6117 13.6777 13.6661 13.4374 13.775 13.2131C13.9771 12.8127 14.3036 12.5564 14.7545 12.5083C15.8663 12.3962 16.3717 13.4374 16.4261 14.4145C16.465 15.0152 16.4572 15.5999 16.4105 16.1766ZM18.4241 21.9593C18.4319 22.0073 18.4708 22.0154 18.4941 22.0394C18.8828 22.3437 19.2949 22.608 19.7458 22.8083C20.0801 22.9604 20.4222 23.0966 20.7876 23.1527C21.0286 23.1927 21.2541 23.1687 21.4718 23.0405C21.7983 22.8403 21.8372 22.3357 21.5106 22.0954C21.3707 21.9913 21.2152 21.9272 21.0442 21.9032C20.7487 21.8552 20.4455 21.8311 20.1423 21.8311C19.7691 21.8311 19.396 21.8472 19.0228 21.8872C18.8284 21.9032 18.6263 21.9272 18.4319 21.9673L18.4241 21.9593ZM11.8624 23.9536C11.8158 23.9376 11.7924 23.9536 11.7691 23.9696C11.326 24.1779 10.8906 24.4021 10.4708 24.6584C10.0898 24.8907 9.72441 25.139 9.39788 25.4433C9.26571 25.5635 9.14909 25.6996 9.04803 25.8518C8.97028 25.9719 8.90808 26.1081 8.89253 26.2523C8.87698 26.3724 8.90808 26.4845 9.00915 26.5566C9.13355 26.6527 9.27349 26.6928 9.42898 26.6527C9.56892 26.6127 9.70109 26.5406 9.81771 26.4605C10.0121 26.3243 10.1909 26.1642 10.3619 25.996C10.8517 25.4914 11.2638 24.9147 11.637 24.322C11.7147 24.2019 11.7847 24.0817 11.8624 23.9536ZM14.8167 16.9134C14.8478 16.8734 14.8556 16.8173 14.8712 16.7693C15.0811 16.1125 15.221 15.4317 15.291 14.7429C15.3143 14.4866 15.3454 14.2303 15.3221 13.966C15.3065 13.8218 15.2832 13.6777 15.221 13.5415C15.1744 13.4374 15.1044 13.3573 14.9956 13.3173C14.809 13.2452 14.6068 13.3413 14.498 13.5335C14.4591 13.5976 14.4358 13.6777 14.4202 13.7498C14.3114 14.1743 14.3192 14.5987 14.358 15.0312C14.4202 15.64 14.5602 16.2246 14.7623 16.8013C14.7779 16.8413 14.7779 16.8814 14.809 16.9134H14.8167ZM15.532 19.8769C15.2832 20.5977 15.0189 21.3426 14.6924 22.0474C14.6379 22.1755 14.5446 22.2076 14.6379 22.1755C15.1511 22.0154 15.9985 21.695 16.6049 21.5428C16.6671 21.5268 16.7293 21.5188 16.7915 21.4707C16.2784 20.9101 15.8741 20.4455 15.532 19.8769Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter0_ddd_466_30243)">
        <path
          d="M33.2401 11.62L21.6201 0C21.6201 5.31 21.6201 7.97 23.2201 9.69C23.3201 9.8 23.4301 9.92 23.5501 10.02C25.2601 11.61 27.9301 11.62 33.2401 11.62Z"
          fill="#000418"
          fillOpacity="0.506"
          shapeRendering="crispEdges"
        />
      </g>
      <path
        d="M21.6202 0.000117302L33.2402 11.6201C33.2402 6.31012 33.2402 3.65012 31.6402 1.93012C31.5402 1.82012 31.4302 1.70012 31.3102 1.60012C29.6002 0.0101166 26.9302 0.000117302 21.6202 0.000117302Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_ddd_466_30243"
        x="17.6201"
        y="-3"
        width="19.6201"
        height="19.6201"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0 0 0 0.051 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_466_30243"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="1"
          operator="erode"
          in="SourceAlpha"
          result="effect2_dropShadow_466_30243"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0 0 0 0.051 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_466_30243"
          result="effect2_dropShadow_466_30243"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.055 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_466_30243"
          result="effect3_dropShadow_466_30243"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_466_30243"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_466_30243">
        <path
          d="M0.620117 11.7C0.620117 6.33443 0.620117 3.65165 2.21418 1.9272C2.32082 1.81183 2.43195 1.7007 2.54731 1.59406C4.27176 0 6.95455 0 12.3201 0H20.9201C26.2857 0 28.9685 0 30.6929 1.59406C30.8083 1.7007 30.9194 1.81183 31.0261 1.9272C32.6201 3.65165 32.6201 6.33443 32.6201 11.7V26.3C32.6201 31.6656 32.6201 34.3484 31.0261 36.0728C30.9194 36.1882 30.8083 36.2993 30.6929 36.4059C28.9685 38 26.2857 38 20.9201 38H12.3201C6.95455 38 4.27176 38 2.54731 36.4059C2.43195 36.2993 2.32082 36.1882 2.21418 36.0728C0.620117 34.3484 0.620117 31.6656 0.620117 26.3V11.7Z"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_466_30243">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(7.62012 12)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default PDFFileIcon;
